interface DropdownProps {
  id: string;
  className: string;
  label?: string;
  small?: string | null;
  showLabel?: boolean;
  required?: boolean;
  children?: React.ReactNode;
  state?: any;
  stateName: string;
  onChange?: any;
  defaultValue: any;
}

export default function Dropdown({
  id,
  className,
  label,
  small,
  showLabel,
  required,
  children,
  state,
  stateName,
  onChange,
  defaultValue,
}: DropdownProps) {
  return (
    <div className="my-auto">
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-${
            small === null ? 3 : 1
          } block text-left text-sm font-medium text-black`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`block text-left text-sm font-medium text-black`}
        />
      )}
      {small !== null && (
        <p className="text-xs text-left text-secondary italic mb-3">{small}</p>
      )}
      <div className={className}>
        <select
          id={id}
          className="block w-full appearance-none rounded-md border border-secondary/40 bg-light/20 px-3 py-2 text-black placeholder-secondary focus:border-primary focus:bg-light/40 focus:outline-none focus:ring-primary sm:text-sm"
          required={required}
          onChange={(e) => onChange({ ...state, [stateName]: e.target.value })}
          defaultValue={defaultValue}
        >
          {children}
        </select>
      </div>
    </div>
  );
}

Dropdown.defaultProps = {
  label: "",
  small: null,
  showLabel: true,
  required: false,
  children: null,
  state: null,
};
